import { useContext } from 'react';
import { PlayerContext } from '../../../../context/PlayerContext';
import './ConnectionStatus.css';

const LABELS: Record<string, string> = {
    connected: 'Synced',
    connecting: 'Connecting…',
    disconnected: 'Offline',
};

export function ConnectionStatus(): React.JSX.Element {
    const { connectionStatus } = useContext(PlayerContext);

    return (
        <span className="connectionStatus" title={LABELS[connectionStatus]}>
            <span className={`connectionStatusDot connectionStatusDot--${connectionStatus}`} />
            <span className="connectionStatusLabel">{LABELS[connectionStatus]}</span>
        </span>
    );
}
